export default __webpack_public_path__ + "static/media/measuring-tape-gray-icon.ba5eea31.svg";